import QuillEditor from './QuillEditor.vue';

/** Registers <ckeditor> globally — same tag the CKEditor views already use. */
export default {
	install(app) {
		app.component('ckeditor', QuillEditor);
	},
};
